import React from "react"
import { withTranslation } from 'react-i18next'
import { Button, Card, Col, Container, Form, Row, Tab, Tabs } from "react-bootstrap"
import { compose, getAllModalFunctions, getDataFromModals } from "../../../utils"
import { withTLService } from "../../hoc"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import UserRightTable from "../../modal-elements/user-right-table"
import BaseModal from "../base-modal"
import JsonEditorModal from "./json-editor"

class ModalAddEditTaskType extends BaseModal {
    _isMounted = false

    state = {
        tabsSetting: 'user-right-tab',
        jsonModalOpen: false,
        jsonModalOpenShared: false,
        functionOptions: [],
        cronOptions: [],
    }

    refreshData() {
        const { index } = this.props
        const { id, rights, old_rights } = getDataFromModals(this.props, index)
        if (id > 0 && (!old_rights || old_rights.length === 0)) {
            this.props.modalUpdateData(index, {
                old_rights: rights
            })
        }

    }

    componentDidMount() {
        this._isMounted = true
        this.refreshData()
        this.loadEnumOptions()
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    onChangeSettingTabs = (event) => {
        this.setState({ tabsSetting: event })

    }

    handleSave = (value) => {
        const { index } = this.props
        this.props.modalUpdateData(index, { settings: value })
        this.setState({ jsonModalOpen: false })
    }

    handleSaveShared = (value) => {
        const { index } = this.props
        this.props.modalUpdateData(index, { shared_settings: value })
        this.setState({ jsonModalOpenShared: false })
    }

    loadEnumOptions = async () => {
        const token = this.props?.userData?.token
        const { tlService } = this.props

        if (!tlService || !token) {
            return
        }

        let functionOptions = []
        try {
            const response = await tlService.getTaskTypeFunctions(token)
            functionOptions = Array.isArray(response?.data) ? response.data : []
        } catch (error) {
            console.error('Failed to load task type functions', error)
        }

        let cronOptions = []
        try {
            const response = await tlService.getTaskTypeCron(token)
            cronOptions = Array.isArray(response?.data) ? response.data : []
        } catch (error) {
            console.error('Failed to load task type cron expressions', error)
        }

        if (!this._isMounted) {
            return
        }

        this.setState({ functionOptions, cronOptions })
    }

    render() {
        const { index } = this.props
        const { name, description, rights, priority, function: func, cron, settings, shared_settings } = getDataFromModals(this.props, index)

        const {
            t: translate
        } = this.props
        const { tabsSetting, functionOptions, cronOptions } = this.state

        const functionValue = func || ''
        const cronValue = cron || ''

        return (
            <Container>
                <Row>
                    <Col md={6}>
                        <Card className="p-4 shadow-sm">
                            <Card.Title className="text-center font-weight-bold mb-4">{translate('Task Details')}</Card.Title>
                            <Form>
                                <Form.Group as={Row} className="mb-3" controlId="formName">
                                    <Form.Label column sm={4} className="text-end">
                                        {translate('Name')}
                                    </Form.Label>
                                    <Col sm={8}>
                                        <Form.Control
                                            size="sm"
                                            type="text"
                                            value={name}
                                            name="name"
                                            onChange={e => this.handleChange(e)}
                                            placeholder={translate('Task name')}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="formDescription">
                                    <Form.Label column sm={4} className="text-end">
                                        {translate('Description')}
                                    </Form.Label>
                                    <Col sm={8}>
                                        <Form.Control
                                            size="sm"
                                            type="text"
                                            value={description}
                                            name="description"
                                            onChange={e => this.handleChange(e)}
                                            placeholder={translate('Task description')}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="formFunction">
                                    <Form.Label column sm={4} className="text-end">
                                        {translate('Function')}
                                    </Form.Label>
                                    <Col sm={8}>
                                        <Form.Control
                                            size="sm"
                                            as="select"
                                            value={functionValue}
                                            name="function"
                                            onChange={e => this.handleChange(e)}
                                        >
                                            <option value="">{translate('Select function')}</option>
                                            {functionOptions.map(option => (
                                                <option key={option.name} value={option.name}>{option.name}</option>
                                            ))}
                                        </Form.Control>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="formPriority">
                                    <Form.Label column sm={4} className="text-end">
                                        {translate('Priority')}
                                    </Form.Label>
                                    <Col sm={8}>
                                        <Form.Control
                                            size="sm"
                                            type="number"
                                            value={priority}
                                            name="priority"
                                            onChange={e => this.handleChange(e)}
                                            placeholder={translate('Task priority')}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="formCron">
                                    <Form.Label column sm={4} className="text-end">
                                        {translate('Cron')}
                                    </Form.Label>
                                    <Col sm={8}>
                                        <Form.Control
                                            size="sm"
                                            as="select"
                                            value={cronValue}
                                            name="cron"
                                            onChange={e => this.handleChange(e)}
                                        >
                                            <option value="">{translate('Select cron')}</option>
                                            {cronOptions.map(option => (
                                                <option key={option.id ?? option.cron} value={option.cron}>{option.name}</option>
                                            ))}
                                        </Form.Control>
                                    </Col>
                                </Form.Group>
                            </Form>
                        </Card>
                    </Col>
                </Row>
                <h1 className="h5 mb-0 text-gray-800 my-3">{translate("Options")}</h1>
                <Tabs className="font-smaller" id="tab-set" activeKey={tabsSetting}
                    onSelect={(k) => this.onChangeSettingTabs(k)}>
                    <Tab tabClassName="font-smaller text-danger" key='user-right-tab' eventKey='user-right-tab'
                        title={translate('User right')}>
                        <UserRightTable
                            translate={translate}
                            updateData={(name, value) => this.handleChange({ target: { name, value } })}
                            rights={rights}
                            rightFieldName='rights'
                        />
                    </Tab>
                    <Tab tabClassName="font-smaller" key='setting-tab' eventKey='setting-tab' title={translate('Settings')}>
                        <Row className="mb-3 mt-2">
                            <Col md={8}>
                                <Form.Control
                                    size="sm"
                                    type="text"
                                    onClick={() => this.setState({ jsonModalOpen: true })}
                                    value={typeof settings === "object" ? JSON.stringify(settings) : settings || ''}
                                    name="settings"
                                    readOnly
                                    placeholder={translate('Task settings')}
                                />
                            </Col>
                            <Col md={4}>
                                <Button
                                    className="fas fa-edit"
                                    onClick={() => this.setState({ jsonModalOpen: true })} />
                            </Col>
                        </Row>
                        <JsonEditorModal
                            open={this.state.jsonModalOpen}
                            onClose={() => this.setState({ jsonModalOpen: false })}
                            value={settings}
                            onSave={this.handleSave}
                            title={translate('Task Settings')}
                        />
                    </Tab>
                    <Tab tabClassName="font-smaller" key='shared-setting-tab' eventKey='shared-setting-tab' title={translate('Shared Settings')}>
                        <Row className="mb-3 mt-2">
                            <Col md={8}>
                                <Form.Control
                                  size="sm"
                                  type="text"
                                  onClick={() => this.setState({ jsonModalOpenShared: true })}
                                  value={typeof shared_settings === "object" ? JSON.stringify(shared_settings) : shared_settings || ''}
                                  name="shared_settings"
                                  readOnly
                                  placeholder={translate('Task shared_settings')}
                                />
                            </Col>
                            <Col md={4}>
                                <Button
                                  className="fas fa-edit"
                                  onClick={() => this.setState({ jsonModalOpenShared: true })} />
                            </Col>
                        </Row>
                        <JsonEditorModal
                          open={this.state.jsonModalOpenShared}
                          onClose={() => this.setState({ jsonModalOpenShared: false })}
                          value={shared_settings}
                          onSave={this.handleSaveShared}
                          title={translate('Task Shared Settings')}
                        />
                    </Tab>
                </Tabs>
            </Container>
        )
    }
}

const mapStateToProps = ({ userData, modalData, openData, adminData }) => {
    return { userData, openData, modalData, adminData }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        ...getAllModalFunctions(),
    }, dispatch)
}

export default compose(
    withTranslation(),
    withTLService(),
    connect(mapStateToProps, mapDispatchToProps)
)(ModalAddEditTaskType)